import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { productShortName, systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-forest-800 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-238" data-mp="3bh233qpffq8m">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-239" data-mp="36jabkxsp264y">
        <span className="inline-flex items-center gap-2 rounded-full bg-gold-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-forest-900" data-id="element-240" data-mp="31l8swdz6k8u0">
          <AwardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-241" data-mp="2wrw4o4yey41s" /> The most comprehensive mining & mineral resources
          teaching system in the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-242" data-mp="2nulrge21c4u8">
          {productShortName}
        </h2>
        <p className="mt-3 font-semibold text-forest-100" data-id="element-243" data-mp="2dumn6tcnf0n6">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach mining with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-244" data-mp="18qg9ac59yk69">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-cream/10 bg-forest-900/50 p-4 text-sm font-semibold text-forest-100" data-id="element-245" data-mp="u2d0kuzukudr">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-300" aria-hidden="true" data-id="element-246" data-mp="1cqqc5fxrsugw" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl bg-cream p-6 text-left text-lg font-bold leading-relaxed text-forest-900 shadow-lg shadow-black/20" data-id="element-247" data-mp="1cmjcd2x5cdf">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-forest-600" aria-hidden="true" data-id="element-248" data-mp="693alg5f06uq" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          mining works, why safety matters, and how mining contributes to modern society while managing environmental and
          social responsibility.
        </p>
      </div>
    </section>;
}